import { modalController } from '@ionic/core';
import { Component, Event, EventEmitter, Fragment, h, Prop } from '@stencil/core';
import { DateUtils, PersonDoc, WorkflowState, WorkflowStateComplete } from 'common';

@Component({
  tag: 'workflow-history-modal',
  styleUrl: 'workflow-history-modal.css',
})
export class WorkflowHistoryModal {
  static async presentModal(people: PersonDoc[], workflow: WorkflowState[], statesComplete: WorkflowStateComplete[]): Promise<WorkflowState | null> {
    const modal = await modalController.create({
      component: 'workflow-history-modal',
      componentProps: { statesComplete, workflow, people },
      cssClass: 'modal-height-auto concourse-modal',
      backdropDismiss: false,
    });
    return new Promise(async resolve => {
      modal.addEventListener('selectState', (e: CustomEvent) => {
        modal.dismiss();
        resolve(e.detail);
      });
      modal.addEventListener('cancel', () => {
        modal.dismiss();
        resolve(null);
      });
      await modal.present();
    });
  }

  @Prop() people: PersonDoc[];
  @Prop() statesComplete: WorkflowStateComplete[];
  @Prop() workflow: WorkflowState[];
  @Event() selectState: EventEmitter<WorkflowState>;

  dismiss() {
    modalController.dismiss();
  }

  render() {
    return (
      <Fragment>
        <modal-header modalTitle="History Details" onDismiss={() => this.dismiss()} />
        <div class="ion-padding">
          {this.statesComplete.map(complete => {
            const person = this.people.find(p => p._id === complete.user_id);
            const state = this.workflow.find(s => s.id === complete.state_id);
            return (
              <div>
                <ion-label>
                  <h2>{state?.pastTense ?? complete.state_id}</h2>
                  <p>{DateUtils.formatIso(complete.date)}</p>
                </ion-label>
                <person-chip-detailed person={person} background="transparent " />
              </div>
            );
          })}
        </div>
      </Fragment>
    );
  }
}
